<template>
    <div v-if="!menuhide">
        <div class="sidebar-left" v-if="!activeTab">
            <left-menu></left-menu>
            <router-link to="/checklist"><img :src="s3+'/images/Checklist-ad-350.jpg'" alt="Safety Checklist" /></router-link>
            <router-link to="/quick-guides"><img :src="s3+'/images/Quick-Compliance-350.jpg'" alt="Quick Guides" /></router-link>
        </div>
         <div class="card default" v-else-if="!isMobile()">
            <div class="card-header">Your Account</div>
            <div class="account-sidebar card-body p-0">
                <ul>
                    <li>
                        <a href="#" :class="{ active:activeTab === 'accounts' || activeTab === 'Change Password' || activeTab === 'orderhistory' } ">My Account</a>
                        <ul class="sub-nav">
                            <li>
                                <router-link :class="{ active:activeTab === 'accounts' }" to="/accounts" v-if="$store.state.auth"><span class="li-hyphen">-</span> Edit Your Details</router-link>
                            </li>
                            <li>
                                <router-link :class="{ active:activeTab === 'Change Password' }" to="/accounts-passwd" v-if="$store.state.auth"><span class="li-hyphen">-</span> Change Your Password</router-link>
                            </li>
                            <li>
                                <router-link :class="{ active:activeTab === 'orderhistory' }" to="/accounts/orders" v-if="$store.state.auth"><span class="li-hyphen">-</span> View Order History</router-link>
                            </li>
                        </ul>
                    </li>
                    <li v-if="getCustomerId()">
                        <router-link :class="{ active:activeTab === 'bookeelearningcourse' }" to="/credit-booking" v-if="$store.state.auth">Book Elearning Courses</router-link>
                    </li>
                    <!-- <li v-if="getCustomerId()">
                        <router-link :class="{ active:activeTab === 'corporate-credit' }" to="/redirect-corporate-credit" v-if="$store.state.auth">Redirect Book Elearning Courses</router-link>
                    </li> -->
                    <li v-if="getCustomerId()">
                        <router-link :class="{ active:activeTab === 'mydelegate' }" to="/mydelegate" v-if="$store.state.auth">My Delegate Certificates</router-link>
                    </li>
                    <!-- <li v-if="getCustomerId()">
                        <router-link :class="{ active:activeTab === 'corporate-certificate' }" to="/redirect-certificate" v-if="$store.state.auth">Redirect Delegate Certificates</router-link>
                    </li> -->
                   <!-- <li>
                        <router-link :class="{ active:activeTab === 'redirect' }" to="/redirect-corporate" v-if="$store.state.auth">Redirect My Courses</router-link>
                    </li> -->
                    <li>
                        <router-link :class="{ active:activeTab === 'mycourse' }" to="/mycourse" v-if="$store.state.auth">My Courses</router-link>
                    </li>
                    <!-- <li>
                        <router-link :class="{ active:activeTab === 'corporate-course' }" to="/redirect-corporate-course" v-if="$store.state.auth">Redirect My Courses</router-link>
                    </li> -->
                    <li>
                        <router-link :class="{ active:activeTab === 'download' }" to="/download" v-if="$store.state.auth">Downloads</router-link>
                    </li>
                    <li v-if="getCustomerId()">
                        <router-link :class="{ active:activeTab === 'catalog_request' }" to="/accounts/catalog_request" v-if="$store.state.auth">Request a catalogue</router-link>
                    </li>
                    <li>
                        <router-link to="/logout" v-if="$store.state.auth">Logout</router-link>
                    </li>
                </ul>
            </div>
        </div>
        
    </div>
</template>

<script>
    import LeftMenu from '../components/LeftMenu';
    import GenericMixin from "@/mixins/GenericMixin";
    export default {
        name: "sidebar",
        mixins: [GenericMixin],
        data() {
            return {
                s3: process.env.VUE_APP_CDN_IMAGE_URL,
                menuhide: false,
                activeTab: ""
            };
        },
        components: {
            'left-menu': LeftMenu,
        },
        mounted() {
            this.activeTab = null;
            if (this.$store.state.auth) {
                if (this.$router.currentRoute.meta.requiresAuth) {
                    this.activeTab = this.$router.currentRoute.name;
                }
            }
            if (this.$router.currentRoute.meta.requiresAuth) {
                if (
                    this.$router.currentRoute.name == "payment" ||
                    this.$router.currentRoute.name == "make-payment" ||
                    this.$router.currentRoute.name == "iFrameForPayment" ||
                    this.$router.currentRoute.name == "confirm" ||
                    this.$router.currentRoute.name == "invoice" ||
                    this.$router.currentRoute.name == "delivery" ||
                    this.$router.currentRoute.name == "paypal-confirm" ||
                    this.$router.currentRoute.name == "subscribe-basket" ||
                    this.$router.currentRoute.name == "change-lms-invoice" ||
                    this.$router.currentRoute.name == "checkout-lms" ||
                    this.$router.currentRoute.name == "subscription-make-payment" ||
                    this.$router.currentRoute.name == "license-processing-payment" ||
                    this.$router.currentRoute.name == "thankyou-subscriber"
                ) {
                    this.menuhide = true;
                }
            }
            if (this.$router.currentRoute.meta.requireVisitor) {
                if (
                    this.$router.currentRoute.name == "basket" ||
                    this.$router.currentRoute.name == "invoice" ||
                    this.$router.currentRoute.name == "delivery" ||
                    this.$router.currentRoute.name == "login" ||
                    this.$router.currentRoute.name == "forgot" ||
                    this.$router.currentRoute.name == "quick guides more" ||
                    this.$router.currentRoute.name == "payment" ||
                    this.$router.currentRoute.name == "make-payment" ||
                    this.$router.currentRoute.name == "iFrameForPayment" ||
                    this.$router.currentRoute.name == "confirm" ||
                    this.$router.currentRoute.name == "bookingform" ||
                    this.$router.currentRoute.name == "booking-confirm" ||
                    this.$router.currentRoute.name == "login_download" ||
                    this.$router.currentRoute.name == "order-form"
                ) {
                    this.menuhide = true;
                }
                if (
                    this.$router.currentRoute.name == "cms" ||
                    this.$router.currentRoute.name == "help" ||
                    this.$router.currentRoute.name == "contact" ||
                    this.$router.currentRoute.name == "quick guides" ||
                    this.$router.currentRoute.name == "help/downloads" ||
                    this.$router.currentRoute.name == "help/about-us" ||
                    this.$router.currentRoute.name == "help/ways-to-pay" ||
                    this.$router.currentRoute.name == "help/privacy-policy" ||
                    this.$router.currentRoute.name == "help/terms-conditions" ||
                    this.$router.currentRoute.name == "help/technical-faq" ||
                    this.$router.currentRoute.name == "help/accessibility-statement" ||
                    this.$router.currentRoute.name == "help/site-map" ||
                    this.$router.currentRoute.name == "help/request-a-catalogue"
                ) {
                    this.menuhide = false;
                }
            }
        },
        watch: {
            $route(to, from) {
                this.activeTab = null;
                if (this.$store.state.auth) {
                    if (this.$router.currentRoute.meta.requiresAuth) {
                        this.activeTab = this.$router.currentRoute.name;
                    }
                }
                if (this.$router.currentRoute.meta.requiresAuth) {
                    if (
                        this.$router.currentRoute.name == "payment" ||
                        this.$router.currentRoute.name == "make-payment" ||
                        this.$router.currentRoute.name == "iFrameForPayment" ||
                        this.$router.currentRoute.name == "confirm" ||
                        this.$router.currentRoute.name == "invoice" ||
                        this.$router.currentRoute.name == "delivery" ||
                        this.$router.currentRoute.name == "paypal-confirm" ||
                        this.$router.currentRoute.name == "subscribe-basket" ||
                        this.$router.currentRoute.name == "change-lms-invoice" ||
                        this.$router.currentRoute.name == "checkout-lms" ||
                        this.$router.currentRoute.name == "subscription-make-payment" ||
                        this.$router.currentRoute.name == "license-processing-payment" ||
                        this.$router.currentRoute.name == "thankyou-subscriber"
                    ) {
                        this.menuhide = true;
                    }
                }
                if (this.$router.currentRoute.meta.requireVisitor) {
                    if (
                        this.$router.currentRoute.name == "basket" ||
                        this.$router.currentRoute.name == "login" ||
                        this.$router.currentRoute.name == "forgot" ||
                        this.$router.currentRoute.name == "forgot password" ||
                        this.$router.currentRoute.name == "quick guides more" ||
                        this.$router.currentRoute.name == "bookingform" ||
                        this.$router.currentRoute.name == "booking-confirm" ||
                        this.$router.currentRoute.name == "login_download" ||
                        this.$router.currentRoute.name == "order-form"
                    ) {
                        this.menuhide = true;
                    }
                    if (
                        this.$router.currentRoute.name == "cms" ||
                        this.$router.currentRoute.name == "help" ||
                        this.$router.currentRoute.name == "contact" ||
                        this.$router.currentRoute.name == "quick guides" ||
                        this.$router.currentRoute.name == "help/downloads" ||
                        this.$router.currentRoute.name == "help/about-us" ||
                        this.$router.currentRoute.name == "help/ways-to-pay" ||
                        this.$router.currentRoute.name == "help/privacy-policy" ||
                        this.$router.currentRoute.name == "help/terms-conditions" ||
                        this.$router.currentRoute.name == "help/technical-faq" ||
                        this.$router.currentRoute.name == "help/accessibility-statement" ||
                        this.$router.currentRoute.name == "help/site-map" ||
                        this.$router.currentRoute.name == "help/request-a-catalogue"
                    ) {
                        this.menuhide = false;
                    }
                }
            }
        },
        methods: {
            clicked($this) {
                // if($this.srcElement.parentElement.classList.length> 1){
                //     $($this.srcElement.parentElement).removeClass("selected");
                // }
                // else{
                //     $($this.srcElement.parentElement).addClass("selected");
                // }
                var current = document.getElementsByClassName("dropright selected");
                if (current.length > 0) {
                    //$($this.srcElement.parentElement).removeClass("selected");
                    current[0].className = current[0].className.replace(
                        "dropright selected",
                        "dropright"
                    );
                    $($this.srcElement.parentElement).addClass("selected");
                } else {
                    $($this.srcElement.parentElement).addClass("selected");
                }
            }
        }
    };
</script>
